import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {EnvironmentHelper} from '../../../../environments/environment-helper';
import { SsoUserService } from 'src/app/auth/sso-user.service';

@Injectable({
  providedIn: 'root'
})
export class BearerInterceptorService implements HttpInterceptor {

  constructor(private userService: SsoUserService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.url.includes(EnvironmentHelper.get('webEamConfig').url)) {
      return next.handle(request);
    }

    if (this.userService.accessToken !== '') {
      request = request.clone({
        headers: request.headers.append('Authorization-Access', `Bearer ${this.userService.accessToken}`)
      });
    }

    if (this.userService.idToken !== '') {
      request = request.clone({
        headers: request.headers.append('Authorization', `Bearer ${this.userService.idToken}`)
      });
    }

    return next.handle(request);
  }
}
